export default {
  title: 'Wekelijkse prestaties',
  messages_sent: 'Verzonden berichten',
  messages_delivered: 'Bezorgde berichten',
  click_rate: 'Gemiddeld klikpercentage',
  awaiting: 'In afwachting van bevestiging',
  legend: {
    sent: 'Verzonden',
    clicked: 'Geklikt',
    delivered: 'Bezorgd',
  },
  error_messages: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
